import { TReduxActions } from '../../actions';
import { EListingModalActionType, EListingModalMode, EOffersFetchingMode } from '../../actions/listingModal';

export interface IListingModalState {
  open: boolean;
  mode: EListingModalMode;
  offersFetchingMode: EOffersFetchingMode;
}

export const defaultState: IListingModalState = {
  open: false,
  mode: EListingModalMode.UNSET,
  offersFetchingMode: EOffersFetchingMode.NONE,
};

export const listingModalReducer = (state = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case EListingModalActionType.Toggle: {
      return { ...state, ...action.payload };
    }
    case EListingModalActionType.SetOffersFetchingMode: {
      return { ...state, offersFetchingMode: action.payload };
    }
    default: {
      return state;
    }
  }
};
